import React from 'react';
import { BundleLanding } from '../components/Product/BundleLanding';

const DynamicPage: React.FC = () => (
  <BundleLanding
    bundleId="dynamic-duo"
    seoTitle="Dynamic Pack — Two-Tub Hydration & Vitamin Recovery"
    seoDescription="The Dynamic Pack from RaveRemedy: two tubs of premium hydration and vitamin recovery blend in your choice of flavours. Free shipping Australia-wide."
    canonical="https://raveremedy.com/dynamic"
    heroTagline="Two tubs, your pick of flavours — free shipping Australia-wide."
  />
);

export default DynamicPage;
